import {cloneDeep, isArray, pull, mergeWith} from 'lodash';

import {RecursivePartial} from 'types';

type Observer<T> = ((value: T, prevValue?: T) => void);
export type Subscription = () => void;

export class Observable<T> {
    private readonly observers: Observer<T>[] = [];
    private readonly initialValue: T;
    private value: T;

    constructor(initialValue: T) {
        this.initialValue = initialValue;
        this.value = cloneDeep(initialValue);
    }

    getValue(): T {
        return this.value;
    }

    setValue(value: T): void {
        const prevValue = this.value;
        this.value = value;
        this.notifyObservers(prevValue);
    }

    resetValue(partialValue?: RecursivePartial<T>): void {
        const value = cloneDeep(this.initialValue);
        this.mergeAndSet(value, partialValue);
    }

    mergeValue(partialValue: RecursivePartial<T>): void {
        this.mergeAndSet(this.value, partialValue);
    }

    subscribe(observer: Observer<T>): Subscription {
        this.observers.push(observer);

        if (this.value) {
            observer(this.value);
        }

        return () => {
            pull(this.observers, observer);
        };
    }

    private mergeCustomizer(value1Prop: any, value2Prop: any) {
        if (isArray(value2Prop)) {
            return value2Prop;
        }
    }

    private mergeAndSet(value1: T, value2: RecursivePartial<T>) {
        this.setValue(mergeWith({}, value1, value2, this.mergeCustomizer));
    }

    private notifyObservers(prevValue: T): void {
        this.observers.forEach((sub) => sub(this.value, prevValue));
    }
}
